import React, { useState } from 'react';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { isMobileOnly } from 'react-device-detect';
import MinusIcon from 'mdi-react/MinusIcon';

const IntervalDatePickerField = ({ onChange, setDateRange }) => {
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);

    const handleChange = ({ startDate, endDate }) => {

        setStartDate(startDate);
        setEndDate(endDate);
        if (startDate && endDate) {
            setDateRange({ start: startDate, end: endDate });
        }
        if (onChange) {
            onChange({ start: startDate, end: endDate });
        }
    };

    return (
        <div className="date-picker-container date-picker" style={{ display: 'flex', alignItems: 'center' }}>
           <DatePicker
                selected={startDate}
                selectsStart
                startDate={startDate}
                endDate={endDate}
                onChange={date => handleChange({ startDate: date, endDate })}
                dateFormat="yyyy/MM/dd"
                placeholderText="From"
                minDate={new Date()}
                dropDownMode="select"
                withPortal={isMobileOnly}
                className="custom-date-picker" // Apply custom CSS class
            />
            <MinusIcon className="date-picker__svg" style={{ margin: '0 10px' }} />
            <DatePicker
                selected={endDate}
                selectsEnd
                startDate={startDate}
                endDate={endDate}
                onChange={date => handleChange({ startDate, endDate: date })}
                dateFormat="yyyy/MM/dd"
                placeholderText="To"
                minDate={startDate || new Date()}
                dropDownMode="select"
                withPortal={isMobileOnly}
                className="custom-date-picker" // Apply custom CSS class
            />
        </div>
    );
};

IntervalDatePickerField.propTypes = {
    onChange: PropTypes.func.isRequired,
    setDateRange: PropTypes.func.isRequired,
};

export default IntervalDatePickerField;
